export default "__VITE_ASSET__Cqr5zpSE__"